import Button from '@mui/material/Button';
import MarkUnreadIcon from '@mui/icons-material/Archive';
import React, { useEffect, useState } from 'react';
import { MARK_COMMENT_AS_READ } from '../../../helpers/graphql/comments';
import graphQLClient from '../../../helpers/graphQLClient';

const MarkCommentAsReadButton = ({ comment, onMarkedAsRead }) => {
  const { _id } = comment;
  const [isRead, setMarkAsRead] = useState(undefined);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    if (!changed) setMarkAsRead(comment.isRead);
  }, [{ comment }]);

  const handleMarkRead = () => {
    graphQLClient(MARK_COMMENT_AS_READ, { id: _id }).then(
      ({ markCommentAsRead }) => {
        setChanged(true);
        setMarkAsRead(true);
        if (onMarkedAsRead) onMarkedAsRead();
        if (!markCommentAsRead.success) console.warn(markCommentAsRead);
      },
    );
  };

  if (comment.isRead) return <></>;
  return (
    <Button onClick={handleMarkRead} disabled={isRead} color="inherit">
      <MarkUnreadIcon fontSize="small" />
      <span className="d-none d-xl-block ml-1">Mark as read</span>
    </Button>
  );
};

export default MarkCommentAsReadButton;
